const projectDetails = [
  {
    title: "Seasons of Your Day",
    link: "/project/seasons",
    imgUrl:
      "https://res.cloudinary.com/bodyofwater/image/upload/v1638891605/Portolio/Projects/Seasons/Seasons6_xsqnkv.jpg",
    description:
      "Interactive multimedia web project combining photography, poetry, video and music.",
  },
  {
    title: "React Form",
    link: "/project/form",
    imgUrl:
      "https://res.cloudinary.com/bodyofwater/image/upload/v1638914165/Portolio/Projects/React%20form/Screenshot-Mobile-2_mxcfyj.jpg",
    description:
      "A form built with React, making full use of controlled components and custom validation",
  },
  {
    title: "HandHeld.Org",
    link: "/project/handheld",
    imgUrl:
      "https://res.cloudinary.com/bodyofwater/image/upload/v1644173750/Portolio/Projects/Handheld/HHorg6_ahp6da.jpg",
    description:
      "A minimalist home page to ease you into using the computer for the day",
  },
  {
    title: "Food Feed",
    link: "/project/foodfeed",
    imgUrl:
      "https://res.cloudinary.com/bodyofwater/image/upload/v1620078432/FFstill1_pv6jam.jpg",
    description:
      "A social networking site where users can easily edit any part of a recipe and save it as their own. The best way to share meals with friends for now.",
  },
  // {
  //   title: "Cyborg Social Club",
  //   link: "/project/cyborg",
  //   imgUrl:
  //     "https://res.cloudinary.com/bodyofwater/image/upload/v1620151131/CyborgStill1_ytbdw3.jpg",
  //   description:
  //     "A collaborative project: an e-commerce store of wearable technologies. Working in an Agile team, we produced a fully-functional and intuitive web-store.",
  // },
];

export default projectDetails;
